var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "white",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M963 4096 c-102 -32 -176 -97 -222 -196 -22 -46 -26 -69 -26 -140 0 -76 4 -93 33 -152 38 -77 92 -130 171 -167 l56 -26 1585 0 1585 0 56 26 c79 37 133 90 171 167 29 59 33 76 33 152 0 76 -4 93 -33 152 -38 77 -92 130 -171 167 l-56 26 -1570 2 c-1279 1 -1578 -1 -1612 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963 2896 c-102 -32 -176 -97 -222 -196 -22 -46 -26 -69 -26 -140 0 -76 4 -93 33 -152 38 -77 92 -130 171 -167 l56 -26 1585 0 1585 0 56 26 c79 37 133 90 171 167 29 59 33 76 33 152 0 76 -4 93 -33 152 -38 77 -92 130 -171 167 l-56 26 -1570 2 c-1279 1 -1578 -1 -1612 -11z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M963 1696 c-102 -32 -176 -97 -222 -196 -22 -46 -26 -69 -26 -140 0 -76 4 -93 33 -152 38 -77 92 -130 171 -167 l56 -26 1585 0 1585 0 56 26 c79 37 133 90 171 167 29 59 33 76 33 152 0 76 -4 93 -33 152 -38 77 -92 130 -171 167 l-56 26 -1570 2 c-1279 1 -1578 -1 -1612 -11z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.6f571ff4a91b5f88700bc8fdacf1a606.svg";
export { ForwardRef as ReactComponent };